export default {
  field_empty: "This field cannot be empty.",
  one_active_user: "At least one active user needs to be selected",
  label_range: "Range",
  label_assignees: "Assignees",
  option_past_week: "Past week",
  option_past_month: "Past month",
  option_past_quarter: "Past quarter",
  option_past_year: "Past year",
  option_select_date_range: "Select date range",
  no_users: "No users available",
}
